/**
 * Debug mode (boss, 9 Oct): browser errors and viewer diagnostics are sent to the WMS server
 * (`POST /client-logs`, signed-in users only) so ITCSI can see what failed without screenshots.
 * Best effort: never throws, at most one report per message per minute.
 */
import { api } from './api';

const recent = new Map<string, number>();

/** Debug mode is OFF by default (boss, 9 Oct). Turn on per browser: localStorage.setItem('wms.debug', '1'). */
export function debugOn(): boolean {
  try { return localStorage.getItem('wms.debug') === '1'; } catch { return false; }
}

export function clientLog(reason: string, detail: unknown): void {
  if (!debugOn()) return;
  const key = reason + String(detail).slice(0, 200);
  const now = Date.now();
  if ((recent.get(key) ?? 0) > now - 60_000) return;
  recent.set(key, now);
  const text = [
    `page: ${location.pathname}${location.search}`,
    `agent: ${navigator.userAgent}`,
    `time: ${new Date().toISOString()}`,
    '',
    typeof detail === 'string' ? detail : safeJson(detail),
  ].join('\n').slice(0, 85_000);
  void api('/client-logs', {
    method: 'POST',
    background: true,
    body: { app: 'wms-web', version: (import.meta as { env?: { VITE_APP_VERSION?: string } }).env?.VITE_APP_VERSION ?? 'web', device: navigator.platform || 'browser', reason: reason.slice(0, 190), text },
  }).catch(() => undefined);
}

function safeJson(v: unknown): string {
  if (v instanceof Error) return `${v.name}: ${v.message}\n${v.stack ?? ''}`;
  try { return JSON.stringify(v, null, 2); } catch { return String(v); }
}

/** Global handlers: uncaught errors and promise rejections. */
export function installClientLog(): void {
  window.addEventListener('error', (e) => clientLog('window.error', e.error ?? `${e.message} @ ${e.filename}:${e.lineno}`));
  window.addEventListener('unhandledrejection', (e) => clientLog('unhandledrejection', e.reason));
}
